define('lq/events/actions/update',[
    'lq/events/actions/eventAction',
    'jquery',
    'underscore',
    'lq/uploader',
    'lq/runtimeDispatcher',
    'lq/entityFiltersState',
    'lq',
    'when'
], function (EventAction, $, _, Uploader, RuntimeDispatcher, entityFiltersState, lq, when) {
    'use strict';

    function Update(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(Update, EventAction);

    Update.typeName = 'Update';

    Update.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    Update.prototype.createEventActionRequest = function () {
        return this.validateData.bind(this);
    };

    Update.prototype.validateData = function (requestContinuation, requestCancellation) {
        var self = this;

        this.isDataValid()
            .then(function(validationObj) {
                if(validationObj.isDataValid) {
                    if (self.eventIsEnabled('inputValidated')) {
                        self.triggerEvent('inputValidated');
                    }
                    self.buildRequest(requestContinuation, requestCancellation);
                }
                else {
                    if (self.eventIsEnabled('inputInvalidated')) {
                        self.triggerEvent('inputInvalidated');
                    }
                    requestCancellation();
                }
            })
            .catch(function (e) {
                requestCancellation();
                self.piping.errorHandler.showErrorDialog(e);
            });
    };

    Update.prototype.buildRequest = function (requestContinuation, requestCancellation) {
        var self = this;

        var commandViewModelKeysValues = {};

        _.each(self.eventData.commandViewModelKeys, function (key) {
            var drop = self.piping.dropFactory.findDropByViewModelKey(key);
            var value = drop.getValue();
            commandViewModelKeysValues[key] = value;
        });

        var extraProperties = {};

        if (self.eventData.isEntityFilterEntity)
            extraProperties['Filter'] = entityFiltersState.getStateOfEntityFilters(this.rootDrop);

        var request = {
            eventActionType: "Update",
            command: self.eventData.command,
            commandViewModelKeys: commandViewModelKeysValues,
            uploads: [],
            extraProperties: extraProperties,
            captcha: this.getCaptcha()
        };

        if (self.eventData.fileUploadType === null) {
            requestContinuation(request);
        } else if (self.eventData.fileUploadType === 'fromViewModel') {
            var drop = self.piping.dropFactory.findDropByViewModelKey(self.eventData.fileSourceMorph);

            if(self.requiredValueIsFilledIn(drop)) {
                when(drop.getFile())
                    .then(function (content) {
                        var params = {
                            actionId: self.piping.actionId,
                            dropId: self.eventData.command
                        };

                        $.ajax({
                            type: 'POST',
                            url: lq.getTenantUrl('DynamicContent/AddPromptlessTempFile') + '?' + $.param(params),
                            contentType: "application/json; charset=utf-8",
                            headers: RuntimeDispatcher.csrfHeaders(),
                            data: content,
                            dataType: 'json'
                        }).done(function (response) {
                            if (!response.success && response.errorType === 'sizeLimitExceeded') {
                                if (self.eventIsEnabled('maxFileSizeExceeded'))
                                    self.triggerEvent('maxFileSizeExceeded');
                                else
                                    alert(`File is too large, maximum file size is ${response.maxFileSizeInKb}KB`);

                                requestCancellation();
                                return;
                            } else if (!response.success && response.errorType === 'invalidFileType') {
                                if (self.eventIsEnabled('invalidFileType'))
                                    self.triggerEvent('invalidFileType');
                                else
                                    alert(`File upload rejected: "${response.errorValue}" is not a permitted file.`);

                                requestCancellation();
                                return;
                            } else if (!response.success) {
                                requestCancellation();
                                return;
                            }

                            request.uploads.push(
                                {
                                    fileName: response.fileName,
                                    tempUrl: response.tempUrl
                                });
                            requestContinuation(request);
                        })
                        .catch(function () {
                            requestCancellation();
                        });
                    });
            } else {
                requestCancellation();
            }
        } else if (self.eventData.fileUploadType === 'fromParameter') {
            var file = self.piping.parameters.getValue(self.eventData.fileSourceParameter);
            var xhr = new XMLHttpRequest();
            var fd = new FormData();

            var params = {
                actionId: self.piping.actionId,
                dropId: self.eventData.command
            };

            var url = lq.getTenantUrl('DynamicContent/AddTempFile?' + $.param(params));
            xhr.open("POST", url, true);
            _.each(RuntimeDispatcher.csrfHeaders(), function (value, name) {
                xhr.setRequestHeader(name, value);
            });
            xhr.onreadystatechange = function () {
                if (xhr.readyState !== 4)
                    return;
                if (xhr.status === 200) {
                    var response = JSON.parse(xhr.responseText);
                    request.uploads.push(
                        {
                            fileName: response.fileName,
                            tempUrl: response.tempUrl
                        });
                    requestContinuation(request);
                } else {
                    requestCancellation();
                }
            };
            fd.append("qqfile", file);
            xhr.send(fd);
        } else {
            var uploader = new Uploader(self.piping, self.eventData.command)
                .toTenantUrl("DynamicContent/AddTempFile")
                .withFileFilter(self.eventData.fileUploadAllowedFileTypes === 'custom' ?
                    self.eventData.fileUploadAllowedCustomFileTypes : self.eventData.fileUploadAllowedFileTypes)
                .withMaxFileSize(self.eventData.maxFileSize)
                .withSmartphoneMode(self.eventData.fileUploadModeSmartPhone)
                .withPhotoQuality(self.eventData.photoQuality)
                .withMaxImageDimensions(self.eventData.maxImageDimensions)
                .onFileUploaded(function (uploadResponse) {
                    if (!uploadResponse.success)
                        throw new Error('Upload failed.');

                    request.uploads.push(
                        {
                            fileName: uploadResponse.filename,
                            tempUrl: uploadResponse.tempUrl
                        });
                })
                .onUploadFinished(function () {
                    requestContinuation(request);
                })
                .onFileUploadCancel(function () {
                    requestCancellation();
                    self.triggerEventIfEnabled('fileUploadCancelled');
                })
                .onMaxFileSizeExceeded(function (filename, maxFileSizeInKb) {
                    if (self.eventIsEnabled('maxFileSizeExceeded'))
                        self.triggerEvent('maxFileSizeExceeded');
                    else
                        alert(filename + ' is too large, maximum file size is ' + maxFileSizeInKb + 'KB');
                    requestCancellation();
                });

            if (self.eventData.fileUploadType === "singleFile" || self.eventData.fileUploadType == "newFile") {
                uploader.uploadSingleFile();
            }
            else if (self.eventData.fileUploadType === "multipleFiles") {
                uploader.uploadMultipleFiles();
            }
        }
    };

    Update.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.isDirty)
            this.handleExecutionTrailDirty(continuation);
        else continuation();
    };

    Update.prototype.requiredValueIsFilledIn = function (drop) {
        if (!this.eventData.skipRequiredFields && drop.isVisible() && !drop.isValid()) {
            if (this.eventIsEnabled('requiredFieldsMissing')) {
                this.triggerEvent('requiredFieldsMissing');
            } else {
                alert('* not all required fields are filled in.');
            }
            return false;
        }
        return true;
    };

    Update.prototype.getCaptcha = function () {
        if (!this.eventData.captchaField) return null;

        var captchaDrop = this.piping.dropFactory
            .findDropByName(this.eventData.captchaField);

        if (!captchaDrop.data.captchaInputField) return null;

        return this.piping.dropFactory
            .findDropByName(captchaDrop.data.captchaInputField)
            .getValue();
    };

    Update.prototype.isDataValid = function () {
        var self = this;
        return when.reduce(self.eventData.commandViewModelKeys, function(validationObj, viewModelKey) {
            var drop = self.piping.dropFactory.findDropByViewModelKey(viewModelKey);

            if (!drop)
                throw new Error('Cannot find drop : "' + viewModelKey + '" for update command.');

            if(!drop.isVisible())
                return validationObj;

            if (validationObj.isValidationAlreadyFailed || !self.requiredValueIsFilledIn(drop))
                return {isDataValid: false, isValidationAlreadyFailed: true};

            return drop.performValidation(self.eventActionId)
                .then(function(isDropValid) {
                    return isDropValid ?
                        {isDataValid: isDropValid, isValidationAlreadyFailed: validationObj.isValidationAlreadyFailed} :
                        {isDataValid: false, isValidationAlreadyFailed: validationObj.isValidationAlreadyFailed};
                });
        }, {isDataValid: true, isValidationAlreadyFailed: false});
    };

    return Update;
});

